// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dnd-placeholder{border:dashed gray 4px;background-color:rgba(255,255,255,.8);position:absolute;top:0;bottom:0;left:0;right:0;z-index:9999}.dnd-text{position:absolute;top:50%;right:0;left:0;text-align:center;color:gray;font-size:36px}.dnd-error{background-color:rgba(238,37,37,.8);border:dashed #9d1a1a 4px}.dnd-error-text{color:#9d1a1a}", ""]);
// Exports
module.exports = exports;
